/* Click color change image product */
jQuery(document).ready(function($) {
  jQuery('.engoj_select_color a').each(function(){
    jQuery(this).on("click",function(){
      var engoImage = jQuery(this).data('engojvariant-img');
      jQuery(this).parents('.engoj_grid_parent').find('.engoj_find_img img').attr({ src: engoImage }); 
      return false;
    });
  });
});

jQuery(document).ready(function($) {
  "use strict";

  function jsProdDetails(){
    $('.js_prod_detail').slick({
      dots: true,
      arrows:true,
      infinite: false,
      speed: 300,
      autoplay:false,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow:'<button type="button" class="next-slide">›</button>',
      prevArrow:'<button type="button" class="prev-slide">‹</button>',
    });
  }

  function jsProdRelate(){
    $('.js_product_related').slick({
      dots: true,
      arrows:false,
      infinite: false,
      speed: 300,
      autoplay:false,
      slidesToShow: 4,
      slidesToScroll: 2,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 3 }},
        { breakpoint: 600, settings: { slidesToShow: 2 }},
        { breakpoint: 480, settings: { slidesToShow: 1, dots: false, arrows: true }}
      ]
    });
  }

  function jsCollection(){
    $('.js_collection').slick({
      dots: true,
      arrows:false,
      infinite: false,
      speed: 300,
      autoplay:false,
      slidesToShow: 3,
      slidesToScroll: 2,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 3 }},
        { breakpoint: 600, settings: { slidesToShow: 2 }},
        { breakpoint: 480, settings: { slidesToShow: 1, dots: false, arrows: true }}
      ]
    });
  }

  function slideProductDetail() {
    $('.js_prod_main').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: false,
      infinite: false,
      asNavFor: '.js_prod_sub'
    });
    $('.js_prod_sub').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '.js_prod_main',
      dots: false,
      arrows: false,
      infinite: false,
      vertical: true,
      verticalSwiping: true,
      focusOnSelect: true,
      responsive: [
        { breakpoint: 1200, settings: { vertical: true, infinite: false }},
        { breakpoint: 768, settings: { vertical: true, infinite: false }},
        { breakpoint: 575, settings: { vertical: false, infinite: false }}
      ]
    });
  }

  function slideProductDetailBottom() {
    $('.js_prod_main_bot').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: false,
      infinite: false,
    });
  }

  function sizeGuide(){
    $('.btn_size_guide').on('click',function(){
      $('.content_size_guide').addClass('active');
      $('.js_sticky').removeClass('sticky_content');
      $('.overlay').addClass('active');
    });
    $('.overlay').on('click',function(){
      $('.content_size_guide').removeClass('active');
      $('.overlay').removeClass('active');
    });
    $('.close_size_guide').on('click',function(){
      $('.js_sticky').addClass('sticky_content');
      $('.content_size_guide').removeClass('active');
      $('.overlay').removeClass('active');
    });
  }

  function sortLayout() {
    if ($(window).width() < 1300) {
      $('.size_3').addClass('active');
      $('.size_4').removeClass('active');
      $('.size_5, .size_6').addClass('d-none');
    }
    if ($(window).width() >= 1300) {
      $('.size_3').addClass('active');
      $('.size_4').removeClass('active');
      $('.size_5, .size_6').removeClass('d-none');
    }
    if ($(window).width() < 768) {
      $('.size_2').addClass('active');
      $('.size_4, .size_3, .size_5, .size_6').addClass('d-none');
    }
  }

  function changeProdListGrid(){
    $('.prod_grid').on('click',function(){
      $('.product-grid-view').addClass('active');
      $('.product-list-view').removeClass('active');
      $(this).addClass('active');
      $('.prod_list').removeClass('active');
    });
    $('.prod_list').on('click',function(){
      $('.product-grid-view').removeClass('active');
      $('.product-list-view').addClass('active');
      $(this).addClass('active');
      $('.prod_grid').removeClass('active');
    });
  }

  function FilterPushLeft(){
    $('.js_filter').on('click',function(){
      $('.filter-to-left').toggleClass('active');
      $('.overlay-filter').addClass('active');    
    });
    $('.close_filter, .overlay-filter').on('click',function(){
      $('.filter-to-left, .overlay-filter').removeClass('active'); 
    });
  }

  function heighthdSticky(){
    $('.detail-info').css({'top':function(){
      return $('.js_height_hd').outerHeight() + 10;
    }});
  }

  function listcollection(){
    $('.js_list_col').slick({
      dots: false,
      arrows:false,
      infinite: false,
      speed: 300,
      autoplay:false,
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
        { breakpoint: 1200, settings: { slidesToShow: 4 }},
        { breakpoint: 768, settings: { slidesToShow: 3 }},
        { breakpoint: 575, settings: { slidesToShow: 3 }}
      ]
    });
  }

  jsProdDetails();
  listcollection();
  jsProdRelate();
  slideProductDetail();
  sizeGuide();
  slideProductDetailBottom();
  sortLayout();
  changeProdListGrid();
  FilterPushLeft();
  jsCollection();
  heighthdSticky();
});

jQuery(document).ready(function($) {
  $('[data-toggle="tooltip"]').tooltip(); 
});

jQuery(document).ready(function($) {
  "use strict";
  function menumobile() {
    $('.menuleft').on('click', function() {
      $(this).toggleClass('active');
      $('.box_contentmenu, .box_contentmenu_background').toggleClass('active');     
    });
    $('.box_contentmenu_background, .js-eveland-close').on('click', function() {
      $('.box_contentmenu, .menuleft, .box_contentmenu_background').removeClass('active');
    });
  }
  menumobile();
  /* Pedro Pedals - restore homepage slider (slick-side-h2) */
jQuery(document).ready(function($) {
  "use strict";
  function slidehome2() {
    $('.slick-side-h2').slick({
      dots: true,
      arrows: true,
      infinite: true,
      speed: 600,
      autoplay: true,
      autoplaySpeed: 4000,
      fade: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow:'<button type="button" class="prev-slide">‹</button>',
      nextArrow:'<button type="button" class="next-slide">›</button>',
      responsive: [
        { breakpoint: 768, settings: { arrows: false, dots: true } }
      ]
    });
  }
  slidehome2();
});

});
/* Pedro Pedals – final safe mobile menu toggle (keeps submenu links working) */
jQuery(function ($) {
  $(document).on('click', '.menu-horizon-list', function (e) {
    var $target = $(e.target);

    // Allow normal behaviour for real links inside the submenu
    if ($target.closest('.collapse a').length) {
      return true;
    }

    // Ignore clicks on the arrow itself (handled by Bootstrap)
    if ($target.closest('.toggle-menumobile').length) {
      return;
    }

    var $row = $(this);
    var $toggle = $row.find('.toggle-menumobile');
    var target = $toggle.attr('href'); // e.g. "#c2"
    var $submenu = $(target);

    if (!$submenu.length) return true;

    // Toggle open/close manually
    e.preventDefault();
    e.stopImmediatePropagation();

    if ($submenu.hasClass('show')) {
      $submenu.removeClass('show').slideUp(200);
      $toggle.addClass('collapsed').attr('aria-expanded', 'false');
    } else {
      $submenu.addClass('show').slideDown(200);
      $toggle.removeClass('collapsed').attr('aria-expanded', 'true');
    }

    $row.toggleClass('open');
  });
});

